import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGetFinancialInstitutions } from '../useGetFinancialInstitutions';
export function useFinancialInstitutionsSelect() {
    const { loading, error, financialInstitutions, getFinancialInstitutions } = useGetFinancialInstitutions();
    const [selectedInstitution, setSelectedInstitution] = useState();
    useEffect(() => {
        if (!financialInstitutions || financialInstitutions.length <= 0) {
            getFinancialInstitutions();
        }
    }, [getFinancialInstitutions, financialInstitutions]);
    const institutionOptions = useMemo(() => {
        return financialInstitutions.map(institution => ({
            value: institution.code,
            label: `${institution.code} - ${institution.name}`,
        }));
    }, [financialInstitutions]);
    const getInstitutionByCode = useCallback((item) => {
        return financialInstitutions.find(institution => institution.code === item.code);
    }, [financialInstitutions]);
    const handleInstitutionChange = useCallback((institutionCode) => {
        const institution = getInstitutionByCode(institutionCode);
        setSelectedInstitution(institution);
    }, [getInstitutionByCode]);
    const handleInstitutionClear = useCallback(() => {
        setSelectedInstitution(undefined);
    }, []);
    const resetSelection = useCallback(() => {
        setSelectedInstitution(undefined);
    }, []);
    const handleChange = useCallback((institutionCode, onChange) => {
        if (typeof institutionCode === 'string') {
            const selectedInstitution = financialInstitutions.find(institution => institution.code === institutionCode);
            setSelectedInstitution(selectedInstitution);
            onChange?.(selectedInstitution);
        }
    }, [financialInstitutions]);
    return {
        selectedInstitution,
        loading,
        error,
        institutionOptions,
        financialInstitutions,
        handleInstitutionChange,
        handleInstitutionClear,
        resetSelection,
        handleChange,
    };
}
